import { render, staticRenderFns } from "./Document-non-visitors.vue?vue&type=template&id=6b8859f5"
import script from "./Document-non-visitors.vue?vue&type=script&lang=js"
export * from "./Document-non-visitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports